import { styled, Box } from '@mui/material'
import { generateColor } from '../api/stringToColor'

interface TagColor {
  name: string
}

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: theme.spacing(2.25),
  width: theme.spacing(2.25),
  flexShrink: 0,
  justifyContent: 'center',
  alignItems: 'center'
}))
const Circle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'name'
})<{ name: string }>(({ theme, name }) => ({
  justifyContent: 'center',
  background: generateColor(name),
  height: theme.spacing(1),
  width: theme.spacing(1),
  display: 'block',
  borderRadius: '50%'
}))

function TagColor({ name }: TagColor) {
  return (
    <Wrapper>
      <Circle name={name} />
    </Wrapper>
  )
}

export default TagColor
